import React, { useCallback, useState } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import useMDContext from 'context/MDContext';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 500,
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  noPadding: {
    padding: 0,
  },
}));

const RolloverConfirmation = () => {
  const classes = useStyles();
  const {
    rollover,
    setRollover,
    shouldResetFinancials,
    setShouldResetFinancials,
    shouldExcludeDocuments,
    setShouldExcludeDocuments,
  } = useMDContext();
  const [primaryCapTableChecked, setPrimaryCapTableChecked] = useState(rollover);
  const [resetFinancialPeriodsChecked, setResetFinancialPeriodsChecked] = useState(shouldResetFinancials);
  const [excludeDocumentsChecked, setExcludeDocumentsChecked] = useState(shouldExcludeDocuments);

  const handlePrimaryCapTableChange = useCallback(
    e => {
      setPrimaryCapTableChecked(e.target.checked);
      setRollover(e.target.checked);
    },
    [setRollover]
  );

  const handleResetFinancialPeriodsChange = useCallback(
    e => {
      setShouldResetFinancials(e.target.checked);
      setResetFinancialPeriodsChecked(e.target.checked);
    },
    [setShouldResetFinancials]
  );

  const handleExcludeDocumentsChange = useCallback(
    e => {
      setShouldExcludeDocuments(e.target.checked);
      setExcludeDocumentsChecked(e.target.checked);
    },
    [setShouldExcludeDocuments]
  );

  return (
    <>
      <Typography className={classes.title}>
        By default, the new measurement date will include the valuation, related cap tables, financials, notes, and
        referenced documents.
      </Typography>
      <div className={classes.marginTop}>
        <FormControlLabel
          control={<Checkbox checked={primaryCapTableChecked} onChange={handlePrimaryCapTableChange} />}
          label="Only rollover the primary cap table and financials, exclude the valuation."
        />
        <FormControlLabel
          control={<Checkbox checked={resetFinancialPeriodsChecked} onChange={handleResetFinancialPeriodsChange} />}
          label="Reset the LTM and NTM financial periods to the new measurement date."
        />
        <FormControlLabel
          control={<Checkbox checked={excludeDocumentsChecked} onChange={handleExcludeDocumentsChange} />}
          label="Exclude all documents from the rollover"
        />
      </div>
    </>
  );
};
export default RolloverConfirmation;
